import { View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

import { spacing, useAppTheme } from '@/theme';

interface PaginationFooterProps {
  readonly isFetchingMore: boolean;
  readonly testID?: string;
}

export const PaginationFooter = ({ isFetchingMore, testID }: PaginationFooterProps) => {
  const { colors } = useAppTheme();

  if (!isFetchingMore) {
    return null;
  }

  return (
    <View style={{ paddingVertical: spacing[4], alignItems: 'center' }} testID={testID}>
      <ActivityIndicator color={colors.iconNdPrimary} size="small" />
    </View>
  );
};
